// extracted by mini-css-extract-plugin
module.exports = {"form":"LocationForm_form__3iN5s","container":"LocationForm_container__1sztj","submit":"LocationForm_submit__S_DQJ"};